<template>
  <div
    id="nps"
    :class="`card px-${space} py-${space} mt-${space} wrapper-nps`"
    v-if="items.length > 0 && items[0].total > 0"
  >
    <div>
      <button class="btn" :class="isPanel ? 'font-size-title': ''" style="box-shadow: none;" @click="visible = !visible">
        <i class="fas fa-thumbs-up"></i>
        {{ this.$t('reports.nps.npsLabelReport') }}
      </button>
      <button
        class="btn pull-right"
        style="box-shadow: none;"
        @click="visible = !visible"
      >
        <i class="fas fa-angle-double-right" v-if="!visible"></i>
        <i v-else class="fas fa-angle-double-down"></i>
      </button>
    </div>
    <div class="wrapper-rankings card" v-if="loader">
      <div>
        <!-- <div class="loader d-flex justify-content-center align-items-center">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div> -->
        <b-table
          :fields="fields"
          :items="[0, 1, 2, 3]"
          caption-bottom
          sort-icon-left
        >
          <template v-slot:cell(question)>
            <div>
              <idx-skeleton width="77" height="15" radius="10" />
            </div>
          </template>
          <template v-slot:cell(promoters)>
            <div class="text-center">
              <idx-skeleton width="45" height="15" radius="10" />
            </div>
          </template>
          <template v-slot:cell(neutrals)>
            <div class="text-center">
              <idx-skeleton width="45" height="15" radius="10" />
            </div>
          </template>
          <template v-slot:cell(detractors)>
            <div class="text-center">
              <idx-skeleton width="45" height="15" radius="10" />
            </div>
          </template>
          <template v-slot:cell(score)>
            <div class="text-right text-bold">
              <idx-skeleton width="25" height="15" radius="10" />
            </div>
          </template>
          <template v-slot:cell(total)>
            <div class="text-center text-bold">
              <idx-skeleton width="25" height="15" radius="10" />
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <div v-else>
      <b-collapse v-model="visible" class="mt-2">
        <b-table :id="isPanel ? 'size-panels' : ''" :fields="fields" :items="items" caption-bottom sort-icon-left>
          <template v-slot:cell(promoters)="row">
            <div
              v-if="row.item.type !== 'total'"
              class="text-center nps-promoter"
              :style="`font-size: ${fontSize}px;`"
            >
              {{ formatNps(row.item.promoters) }}%
            </div>
          </template>
          <template v-slot:cell(neutrals)="row">
            <div
              v-if="row.item.type !== 'total'"
              class="text-center nps-neutral"
              :style="`font-size: ${fontSize}px;`"
            >
              {{ formatNps(row.item.neutrals) }}%
            </div>
          </template>
          <template v-slot:cell(detractors)="row">
            <div
              v-if="row.item.type !== 'total'"
              :style="`font-size: ${fontSize}px;`"
              class="text-center nps-detractor"
            >
              {{ formatNps(row.item.detractors) }}%
            </div>
          </template>
          <template v-slot:cell(score)="row">
            <div v-if="row.item.type !== 'total'" class="text-right text-bold" :style="`font-size: ${fontSize}px;`">
              {{ row.item.score }}
            </div>
          </template>
          <template v-slot:cell(total)="row">
            <div class="text-center text-bold" :style="`font-size: ${fontSize}px;`">
              {{ row.item.total }}
            </div>
          </template>
        </b-table>
        <div v-if="!isPanel" class="row">
          <div class="col-12 mt-2 text-right">
            <a
              @click="exportToXLS"
              :title="`${this.$t('reports.exportXlsLabel')}`"
            >
              <span class="xls">
                <i class="fas fa-file-download"></i>
              </span>
            </a>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import XLSX from 'xlsx';
import EmptyState from '@/components/molecules/empty-state';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import api from '@/services/api';
import RadialProgressBar from 'vue-radial-progress';
import EventBus from '../../../../../../eventBus';

export default {
  name: 'ScoreNps',
  props: ['showCollapsed', 'dataGraph'],
  components: {
    EmptyState,
    RadialProgressBar,
    idxSkeleton,
  },
  data: () => ({
    isBusy: false,
    empty: false,
    filter: null,
    userAuth: null,
    visible: true,
    total: 0,
    page: 1,
    limit: 10,
    items: [],
    npsData: [],
    loader: false,
    fields: [],
    totalAnswers: 0,
    lang: 'br',
    isPanel: false,
    space: 2,
    fontSize: 16,
  }),
  watch: {
    actionGroupData: function watchActionGroupData() {
      this.mountNps();
    },
    myActionId: function watchMyActionId() {
      this.mountNps();
    },
    myActionsIds: function watchMyActionsIds() {
      this.mountNps();
    },
    myIh1: function watchMyIh1() {
      this.mountNps();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.mountNps();
    },
    myIh2: function watchMyIh2() {
      this.mountNps();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.mountNps();
    },
    calendarDates: function watchDates() {
      this.mountNps();
    },
    myMetric: function watchMyMetric() {
      this.mountNps();
    },
    'indicatorData.value': function watchMyMetric() {
      this.mountNps();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.mountNps();
    },
    '$i18n.locale': function watchLocale(value) {
      this.lang = value;
      this.mountNps();
    },
  },
  computed: {
    ...mapState('charts', ['filterRankings']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  methods: {
    async mountNps() {
      this.loader = true;
      const response = await api.get(`reports/get-nps`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: this.filterRankings ? this.filterRankings : null,
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          lang: this.lang,
        },
      });
      this.npsData = response.data.npsData;
      this.totalAnswers = response.data.totalAnswers;
      this.items = [];
      this.npsData.map((obj) => {
        let grades = 0;
        obj.grades.map((item) => {
          grades = item + grades;
        });
        this.items.push({
          question: obj.question,
          progress: obj.nps,
          score: obj.nps,
          promoters: obj.promoters,
          neutrals: obj.neutrals,
          detractors: obj.detractors,
          total: obj.total,
        });
        this.total = this.total + obj.total;
        this.isBusy = false;
      });
      this.items.push({
        question: this.$t('reports.nps.totalAnswersLabel'),
        type: 'total',
        total: this.totalAnswers,
      });
      this.loader = false;
    },
    formatNps(num) {
      return num.toFixed(1);
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    exportToXLS() {
      const header = [
        this.$t('reports.nps.addQuestionLabel'),
        this.$t('reports.nps.scoreLabel'),
        this.$t('reports.nps.totalLabel'),
      ];
      const arr = [];
      this.items.forEach((el) => {
        arr.push({
          [this.$t('reports.nps.addQuestionLabel')]: el.question,
          [this.$t('reports.nps.scoreLabel')]: el.score,
          [this.$t('reports.nps.totalLabel')]: el.total,
        });
      });
      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('rankings-1-10');
      const ws = XLSX.utils.json_to_sheet(arr, { header });
      wb.Sheets['rankings-1-10'] = ws;
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );
      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'rankings-1-10.xlsx');
      document.body.appendChild(link);
      link.click();
    },
    async mountCardPanel(data) {
      this.loader = true;
      const response = await api.get(`reports/get-nps`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: null,
          companyId: this.userAuth.companyId,
          actionId: data.actionId ? data.actionId._id : null,
          startDate: '2022-01-01',
          endDate: '2022-07-08',
          ih1: data.ih1 ? data.ih1._id : null,
          // period: data.period ? data.period : null,
          metric: data.metric ? data.metric : null,
          groupId: data.actionGroupId ? data.actionGroupId._id : null,
          indicator: data.indicator ? data.indicator : null,
          indicatorValue: data.valueIndicator ? data.valueIndicator : null,
          // indicatorRange: this.indicatorData.range,
          lang: this.lang,
        },
      });
      this.npsData = response.data;
      this.items = [];
      this.npsData.npsData.map((obj) => {
        let grades = 0;
        obj.grades.map((item) => {
          grades = item + grades;
        });
        this.items.push({
          question: obj.question,
          progress: obj.nps,
          score: obj.nps,
          promoters: obj.promoters,
          neutrals: obj.neutrals,
          detractors: obj.detractors,
          total: obj.total,
        });
        this.total = this.total + obj.total;
        this.isBusy = false;
      });
      this.totalAnswers = 0;
      for (let i = 0; i < this.items.length; i += 1) {
        this.totalAnswers += this.items[i].total;
      }
      this.items.push({
        question: this.$t('reports.nps.totalAnswersLabel'),
        type: 'total',
        total: this.totalAnswers,
      });
      this.loader = false;
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      {
        key: 'question',
        label: this.$t('reports.nps.addQuestionLabel'),
        sortable: true,
        class: 'questionTh',
      },
      { key: 'progress', class: 'progressTh' },
      {
        key: 'promoters',
        label: this.$t('reports.nps.promoterLabel'),
        // sortable: true,  promoterLabel
        class: 'scoreTh',
      },
      {
        key: 'neutrals',
        label: this.$t('reports.nps.neutralLabel'),
        // sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'detractors',
        label: this.$t('reports.nps.detractorLabel'),
        // sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'score',
        label: this.$t('reports.nps.scoreLabel'),
        // sortable: true,
        class: 'scoreTh text-right',
      },
      {
        key: 'total',
        label: this.$t('reports.nps.totalLabel'),
        // sortable: true,
        class: 'totalTh',
      },
    ];
  },
  mounted() {
    this.visible = !this.showCollapsed;
    this.lang = this.$i18n.locale;
    if (this.$route.fullPath.indexOf('panels') !== -1) {
      this.isPanel = true;
      this.mountCardPanel(this.dataGraph);
      EventBus.$on('update-nps', (items) => {
        this.mountCardPanel(items);
      });
      this.space = 0;
      this.fontSize = 12;
    } else {
      this.mountNps();
      this.isPanel = false;
      EventBus.$on('filter-rankings', () => {
        this.mountNps();
      });
      this.score = 2;
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/themes/default/variables.scss';
.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-nps .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-nps .btn .btn-light .collapsed {
  background-color: transparent;
}
.wrapper-rankings.card {
  min-height: 200px;
}
.wrapper-rankings .loader {
  min-height: 200px;
}
.card {
  border: 1px solid #fff;
}
.card-panel {
  border: 1px solid #fff;
}
.nps-promoter {
  background: #4ce595;
  color: white;
  font-weight: bold;
}
.nps-neutral {
  background: #ecdb12;
  color: white;
  font-weight: bold;
}
.nps-detractor {
  background: #d62027;
  color: white;
  font-weight: bold;
}
.text-bold {
  font-weight: bold;
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: #1dc86e;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/components/nps.vue